import { PRIMARY } from 'constants/colors';

import { Box, styled } from '@mui/material';

const DropIndicator = styled(Box)`
  position: relative;
  height: 2px;
  width: 100%;
  background: ${PRIMARY};

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 6px;
    width: 6px;
    border-radius: 50%;
    background: ${PRIMARY};
  }
`;

export default DropIndicator;
